import { IApplicationState } from '../../types/redux';

export function platformReducer(state: IApplicationState['platform'] = 'other'): IApplicationState['platform'] {
  return state;
}
